import script from "./EPIC_UPDATED.vue?vue&type=script&setup=true&lang=ts"
export * from "./EPIC_UPDATED.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__